<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler 
        class="d-lg-none" 
        display="md" 
        mobile
      />
      <b-link 
        class="navbar-brand" 
        to="#"
      >
        <img 
          class="navbar-brand-full" 
          src="img/brand/TRANSPLAN.svg" 
          width="150" 
          height="30" 
          alt="CoreUI Logo"
        >
        <img 
          class="navbar-brand-minimized" 
          src="img/brand/T.svg" 
          width="30" 
          height="30" 
          alt="CoreUI Logo"
        >
      </b-link>
      <SidebarToggler 
        class="d-md-down-none" 
        display="lg"
      />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item 
          class="px-3" 
          to="/dashboard"
        >
          Taakvoortgang
        </b-nav-item>
        <b-nav-dropdown>
          <template slot="button-content">
            <font-awesome-icon icon="history" />
            Historie
          </template>
          <template>
            <b-dropdown-item @click="() => $store.dispatch('clearHistory')">
              <font-awesome-icon icon="trash" /> Historie legen
            </b-dropdown-item>
            <b-dropdown-item 
              v-for="u in $store.getters.history.slice().reverse()" 
              :key="u.unit.id" 
              :to="{name: 'UnitViewRoute',params: {id: u.unit.id}}"
            >
              {{ u.unit.kenmerk }} {{ u.unit.adres }} {{ u.unit.plaats }}
            </b-dropdown-item>
          </template>
        </b-nav-dropdown>
      </b-navbar-nav>
      
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        
        <SidebarNav :nav-items="nav" />
        <div
          v-if="!useNewMenu"
          class="sidebar-menu-toggle px-3 py-2"
        >
          <b-form-checkbox
            v-model="useNewMenu"
            switch
            size="sm"
          >
            <small>Nieuwe menu-indeling</small>
          </b-form-checkbox>
        </div>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view />
        </div>
      </main>
      <!---<AppAside fixed>
        <DefaultAside/>
      </AppAside>--->
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="#">&copy; Transplanadvies</a>
      </div>
      <!--
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
      -->
    </TheFooter>
  </div>
</template>

<script>
import dev from '@/_nav'
import menu from '@/_menu'
import menuNew from '@/_menu_new'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownMssgs from './DefaultHeaderDropdownMssgs'
import DefaultHeaderDropdownTasks from './DefaultHeaderDropdownTasks'
import FontAwesome from '../views/icons/FontAwesome.vue'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    FontAwesome
  },
  data () {

    return {
      type: 'menu',
      useNewMenu: localStorage.getItem('useNewMenu') === 'true'
    }
  },
  computed: {
    nav () {
      if (this.type == 'nav') return dev.items;
      return this.useNewMenu ? menuNew.items : menu.items;
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  mounted () {
    window.addEventListener('menu-layout-changed', this.onMenuLayoutChanged)
  },
  beforeDestroy () {
    window.removeEventListener('menu-layout-changed', this.onMenuLayoutChanged)
  },
  methods: {
    onMenuLayoutChanged (e) {
      const newValue = !!(e && e.detail && e.detail.useNewMenu)
      if (this.useNewMenu !== newValue) {
        this.useNewMenu = newValue
      }
    }
  },
  watch: {
    useNewMenu (newValue) {
      localStorage.setItem('useNewMenu', newValue ? 'true' : 'false')
      window.dispatchEvent(new CustomEvent('menu-layout-changed', { detail: { useNewMenu: newValue } }))
      if (newValue) {
        this.$bvModal.msgBoxOk(
          'Je gebruikt nu de nieuwe menu-indeling. Je kunt op elk moment terugschakelen naar de oude indeling via Instellingen.',
          {
            title: 'Nieuwe menu-indeling',
            okTitle: 'Begrepen',
            centered: true
          }
        )
      }
    }
  }
}
</script>
